"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingOptions = void 0;
var constants_1 = require("../../constants");
/**
 * @property {string}  id - Setting options id
 * @property {string}  curriculum - Setting options curriculum
 * @property {string}  type - Setting options type
 * @property {Option}  options - Setting options
 */
var SettingOptions = /** @class */ (function () {
    function SettingOptions(data) {
        if (data === void 0) { data = {}; }
        Object.assign(this, data);
    }
    Object.defineProperty(SettingOptions.prototype, "isEurekaMath", {
        get: function () {
            var _a;
            return (_a = this.curriculum) === null || _a === void 0 ? void 0 : _a.startsWith(constants_1.CurriculumId.EurekaMath);
        },
        enumerable: false,
        configurable: true
    });
    return SettingOptions;
}());
exports.SettingOptions = SettingOptions;
